var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTriangleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.971 15.2925C71.1637 2.90249 88.8363 2.9025 95.029 15.2925L152.196 129.669C157.785 140.85 149.655 154 137.167 154H22.8328C10.3447 154 2.21513 140.85 7.80379 129.669L64.971 15.2925Z",
    stroke: "#D0274B",
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4453 132C82.759 132 85.4453 129.314 85.4453 126C85.4453 122.686 82.759 120 79.4453 120C76.1316 120 73.4453 122.686 73.4453 126C73.4453 129.314 76.1316 132 79.4453 132Z",
    fill: "#D0274B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1927 68.9689C70.7904 64.1408 74.6005 60 79.4453 60C84.2901 60 88.1002 64.1408 87.6979 68.9689L84.8605 103.017C84.6258 105.834 82.2715 108 79.4453 108C76.6192 108 74.2648 105.834 74.0301 103.017L71.1927 68.9689Z",
    fill: "#D0274B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangleRed);
export default __webpack_public_path__ + "static/media/warning-triangle-red.058d2f1ecd50c01105230d90919d5a13.svg";
export { ForwardRef as ReactComponent };